"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SERVER_PAGINATION_LIMIT_ROWS = exports.SEARCH_PREVIEW_CATEGORIES_LIMIT = exports.SEARCH_PREVIEW_BRANDS_LIMIT = exports.PRODUCT_BOX_SKELETON = exports.PAGINATION_LIMIT_ROWS = exports.PAGINATION_LIMIT_ITEMS = exports.ORIGIN_QUERY_KEY = exports.FOCUS_BANNER_SIZE_IN_PX = exports.EMPTY_BOX = exports.DEFAULT_ORDER_BY = exports.CONTENT_ROWS = exports.CLIENT_PAGINATION_LIMIT_ROWS = exports.BANNER_SPLIT_MOBILE_HEIGHT = exports.BANNER_SPLIT_DESKTOP_HEIGHT = exports.BANNER_SIZE_IN_PX = exports.BANNER_PRODUCT_LISTING_DIVIDER = void 0;
var _models = require("../../models");
// Graphql query using rows not items
const PAGINATION_LIMIT_ROWS = exports.PAGINATION_LIMIT_ROWS = 10;
const SERVER_PAGINATION_LIMIT_ROWS = exports.SERVER_PAGINATION_LIMIT_ROWS = 2;
const CLIENT_PAGINATION_LIMIT_ROWS = exports.CLIENT_PAGINATION_LIMIT_ROWS = PAGINATION_LIMIT_ROWS - SERVER_PAGINATION_LIMIT_ROWS;
// 4 Items per row
const PAGINATION_LIMIT_ITEMS = exports.PAGINATION_LIMIT_ITEMS = SERVER_PAGINATION_LIMIT_ROWS * 4;
const BANNER_SIZE_IN_PX = exports.BANNER_SIZE_IN_PX = {
    Size1: 235,
    Size2: 485
};
const FOCUS_BANNER_SIZE_IN_PX = exports.FOCUS_BANNER_SIZE_IN_PX = {
    Size1: 300,
    Size2: 615
};
const BANNER_SPLIT_MOBILE_HEIGHT = exports.BANNER_SPLIT_MOBILE_HEIGHT = {
    Size1: 195,
    Size2: 190
};
const BANNER_SPLIT_DESKTOP_HEIGHT = exports.BANNER_SPLIT_DESKTOP_HEIGHT = 225;
// Test IDs
const BANNER_PRODUCT_LISTING_DIVIDER = exports.BANNER_PRODUCT_LISTING_DIVIDER = 'banner-product-listing-divider';
const CONTENT_ROWS = exports.CONTENT_ROWS = 'ContentRows';
const EMPTY_BOX = exports.EMPTY_BOX = 'EmptyBox';
const PRODUCT_BOX_SKELETON = exports.PRODUCT_BOX_SKELETON = 'ProductBoxSkeleton';
const ORIGIN_QUERY_KEY = exports.ORIGIN_QUERY_KEY = 'origin';
const DEFAULT_ORDER_BY = exports.DEFAULT_ORDER_BY = _models.PlpOrderBy.Recommended;
const SEARCH_PREVIEW_BRANDS_LIMIT = exports.SEARCH_PREVIEW_BRANDS_LIMIT = 5;
const SEARCH_PREVIEW_CATEGORIES_LIMIT = exports.SEARCH_PREVIEW_CATEGORIES_LIMIT = 5;
